/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

class CustomSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if(this.dataset.flickity) {
      const flickityOptions = JSON.parse(this.dataset.flickity);

      this.slider = new themeVendor.Flickity(this, flickityOptions);
    }
  }
}

customElements.define("custom-slider", CustomSlider);

function extractSectionId(element) {
  element = element.classList.contains("shopify-section") ? element : element.closest(".shopify-section");
  return element.id.replace("shopify-section-", "");
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    this.section = this.closest(".shopify-section");
    this.content = this.querySelector(".upsell--products");

    if(this.getAttribute("product") != "") {
      this.loadRecommendations(this.getAttribute("product"), this.getAttribute("intent") || "related", this.getAttribute("limit"));
    }

    if(this.hasAttribute("cart-update")) {
      document.addEventListener("theme:cart:change", function(e) {
        const cart = e.detail.cart;

        if(cart.items.length != 0) {
          this.loadRecommendations(cart.items[0].product_id, this.getAttribute("intent") || "related", this.getAttribute("limit"));
        } else {
          this.setAttribute("hidden", "");

          if(this.slider) {
            this.slider.destroy();
          }
        }
      }.bind(this));

      this.cartDrawer = document.querySelector("#drawer-cart");
      if(this.cartDrawer) {
        this.cartDrawer.addEventListener("theme:drawer:open", function() {
          setTimeout(function() {
            this.#updateArrows();
          }.bind(this), 0);
        }.bind(this));
      }
    }
  }

  initSlider() {
    this.slider = new themeVendor.Flickity(this.querySelector(".upsell--products"), {
      prevNextButtons: false,
      cellAlign: "left",
      contain: true
    });
    
    this.nextBtn = this.querySelector(".cart__upsell--button.next");
    this.prevBtn = this.querySelector(".cart__upsell--button.previous");

    this.nextBtn.addEventListener("click", () => this.slider.next());
    this.prevBtn.addEventListener("click", () => this.slider.previous());
    
    this.slider.on("ready", this.#updateArrows.bind(this));
    this.slider.on("select", this.#updateArrows.bind(this));
    this.slider.on("settle", this.#updateArrows.bind(this));
    this.slider.on("resize", this.#updateArrows.bind(this));

    this.#updateArrows();
  }

  #updateArrows() {
    const cellsWidth = this.slider.slideableWidth;
    const viewportWidth = this.slider.size.innerWidth;

    const canScroll = cellsWidth > viewportWidth;

    this.prevBtn.disabled = !canScroll || this.slider.selectedIndex === 0;

    this.nextBtn.disabled = !canScroll || this.slider.selectedIndex === this.slider.slides.length - 1;

    this.slider.resize();
  }

  async loadRecommendations(productId, intent, limit) {
    const section = this.section;
    let url = `${Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${extractSectionId(section)}&intent=${intent}`; 
    let response = await fetch(url, { priority: intent === "related" ? "low" : "auto" });
    
    let tempDiv = new DOMParser().parseFromString(await response.text(), "text/html"); 
    let productRecommendationsElement = tempDiv.querySelector("product-recommendations");

    if (productRecommendationsElement.querySelectorAll("product-grid-item").length > 0) {
      this.replaceChildren(...document.importNode(productRecommendationsElement, true).childNodes);
      this.hidden = false;

      this.initSlider();
    } else {
      this.initSlider();
      this.hidden = true;

      if(this.slider) {
        this.slider.destroy();
      }
    }
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class SizeGuide extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const btn = this.querySelector(".size-guide--btn");
    const content = this.querySelector("[data-modal-content]");
    
    if(btn && content) {
      const url = btn.dataset.pageUrl;

      const resp = await (await fetch(url)).text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(resp, "text/html");

      const html = doc.querySelector("#MainContent");

      content.innerHTML += html.innerHTML;
    }
  }
}

customElements.define("size-guide", SizeGuide);

class RAOTable extends HTMLElement {
  #selectedIndex = 0;

  constructor() {
    super();
  }

  connectedCallback() {
    const toggleBtn = this.querySelector(".table__header--toggle-button");
    const toggleValues = this.querySelectorAll(".table__header--toggle-value");

    if(toggleBtn && toggleValues) {
      toggleBtn.addEventListener("click", this.toggle.bind(this, toggleBtn, toggleValues));

      toggleValues[0].addEventListener("click", function() {
        if(parseInt(toggleValues[0].dataset.index) != this.#selectedIndex) {
          this.toggle(toggleBtn, toggleValues);
        }
      }.bind(this));

      toggleValues[1].addEventListener("click", function() {
        if(parseInt(toggleValues[1].dataset.index) != this.#selectedIndex) {
          this.toggle(toggleBtn, toggleValues);
        }
      }.bind(this));
    }
  }

  toggle(toggleBtn, toggleValues) {
    toggleValues[this.#selectedIndex].classList.remove("selected");
    this.querySelector(`.table--block[data-index="${this.#selectedIndex}"]`).classList.add("hidden");

    if(this.#selectedIndex == 0) {
      this.#selectedIndex = 1;

      toggleBtn.classList.add("move");
    } else {
      this.#selectedIndex = 0;

      toggleBtn.classList.remove("move");
    }

    toggleValues[this.#selectedIndex].classList.add("selected");
    this.querySelector(`.table--block[data-index="${this.#selectedIndex}"]`).classList.remove("hidden");
  }
}

customElements.define("rao-table", RAOTable);


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  /*document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });*/

  // Debounced resize listener to bundle changes that trigger document reflow
  //document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
